var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8744 13.6251L21.2494 2.25006M10.0126 13.9805L12.8597 21.3016C13.1106 21.9466 13.236 22.2691 13.4167 22.3632C13.5733 22.4448 13.7599 22.4449 13.9167 22.3635C14.0975 22.2696 14.2233 21.9473 14.4748 21.3026L21.6144 3.00753C21.8415 2.42558 21.955 2.13461 21.8929 1.94868C21.839 1.78721 21.7123 1.6605 21.5508 1.60655C21.3649 1.54444 21.0739 1.65799 20.4919 1.88509L2.19688 9.02463C1.55221 9.2762 1.22988 9.40199 1.13595 9.5828C1.05452 9.73955 1.05463 9.92615 1.13624 10.0828C1.23039 10.2635 1.55287 10.3889 2.19783 10.6397L9.519 13.4869C9.64992 13.5378 9.71538 13.5632 9.7705 13.6025C9.81935 13.6374 9.86208 13.6801 9.89693 13.729C9.93624 13.7841 9.9617 13.8495 10.0126 13.9805Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.10b1766d966e113f15d43f59b2961ee8.svg";
export { ForwardRef as ReactComponent };